import {RouteKey} from 'common/src/modules/routing/routing.enums';
import routingService from 'common/src/modules/routing/routing.service';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {BrandGuidelinesAgentToolName} from '../brandGuidelinesAgent.enums';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';

// Available tab IDs from BrandGuidelinesPageTab enum
const AVAILABLE_TABS = {
  'brand-guidelines': 'Brand Guidelines',
  'brand-assets': 'Brand Assets',
  'brand-personas': 'Brand Personas',
} as const;

function navigateToBrandGuidelinesTabTool() {
  const inputSchema = z.object({
    tabId: z
      .enum(['brand-guidelines', 'brand-assets', 'brand-personas'] as const)
      .describe(
        'The tab ID to navigate to. Available tabs: brand-guidelines, brand-assets, brand-personas',
      ),
  });

  async function execute({
    input: {tabId},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const currentRouteKey = routingService.getCurrentRouteKey();
    const tabDisplayName = AVAILABLE_TABS[tabId];

    // Navigate to Brand Guidelines page with the specified tab
    routingService.goTo({
      url: routingService.getRoutePath(RouteKey.BrandGuidelines),
      queryParams: {
        tabId: tabId,
      },
    });

    // Provide appropriate feedback based on current location
    if (currentRouteKey === RouteKey.BrandGuidelines) {
      return toolResult(`Switched to the ${tabDisplayName} tab.`);
    } else {
      return toolResult(
        `Navigated to the Brand Guidelines page and opened the ${tabDisplayName} tab.`,
      );
    }
  }

  return tool({
    name: BrandGuidelinesAgentToolName.NavigateToBrandGuidelinesTab,
    description: 'Navigate to a specific tab on the Brand Guidelines page',
    displayName: 'Navigating betweem brand guidelines tabs',
    inputSchema,
    execute,
  });
}

export default navigateToBrandGuidelinesTabTool;
